export default __webpack_public_path__ + "static/media/DANGER.626a762b.png";